import type { ReactNode } from 'react';

import {
  Container,
  Layout,
  Content,
  type BackgroundVariant,
  backgroundVariants,
} from './PublicPage.styled';

type PublicPageProps = {
  children: ReactNode;
  backgroundVariant?: BackgroundVariant;
};

export default function PublicPage({
  children,
  backgroundVariant = backgroundVariants.default,
}: PublicPageProps) {
  return (
    <Container $backgroundVariant={backgroundVariant}>
      <Layout>
        <Content>{children}</Content>
      </Layout>
    </Container>
  );
}
